<app-vertical></app-vertical>

<!-- App-wide save-confirmation toasts (SaveFeedbackService). Rendered once
     here so every admin form's saved()/error() surfaces above any page. -->
<app-save-feedback></app-save-feedback>